import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { IAppState } from '../../store/state';
import { selectUser } from '../../store/selectors';
import { MenuItem } from '../../models/menu-item.model';

/**
 * Itens replicados do menu lateral observado em portal-hml.affixtech.com.br (21/08/2026).
 * Ícones são um ponto de partida (FontAwesome) — ajustar para o glifo exato depois da
 * definição do design system.
 */
const MENU_ITEMS: MenuItem[] = [
  { label: 'Home', icon: 'fa-solid fa-house', route: '/home' },
  /*{ label: 'Gestão Médica', icon: 'fa-solid fa-briefcase-medical', route: '/gestao-medica', menuCode: 'menuGestaoMedica' },*/
  /*{ label: 'Pré-Cadastro', icon: 'fa-solid fa-file-circle-plus', route: '/pre-cadastro', menuCode: 'menuPreCadastro' },*/
  { label: 'Comunicados', icon: 'fa-solid fa-bullhorn', route: '/comunicados', menuCode: 'comunicados' },
  { label: 'Atendimento', icon: 'fa-solid fa-headset', route: '/atendimento', menuCode: 'atendimento' },
  { label: 'Controle Usuários', icon: 'fa-solid fa-user-gear', route: '/controle-usuarios', menuCode: 'controle-usuarios' },
  { label: 'Títulos Pendentes', icon: 'fa-solid fa-file-invoice', route: '/titulos-pendentes', menuCode: 'titulos-pendentes' },
  { label: 'Extratos', icon: 'fa-solid fa-coins', route: '/extratos', menuCode: 'extratos' },
  { label: 'Proposta Migração', icon: 'fa-solid fa-right-left', route: '/proposta-migracao', menuCode: 'proposta-migracao' },
  { label: 'IA Retenção', icon: 'fa-solid fa-brain', route: '/ia-retencao', menuCode: 'ia-retencao' },
  { label: 'Financeiro', icon: 'fa-solid fa-sack-dollar', route: '/financeiro', menuCode: 'financeiro' },
  { label: 'Modelo Proposta', icon: 'fa-solid fa-file-lines', route: '/modelo-proposta', menuCode: 'modelo-proposta' },
  /*{ label: 'Estudos Migração', icon: 'fa-solid fa-book-open', route: '/estudos-migracao', menuCode: 'menuEstudosMigracao' },*/
  { label: 'Venda Online', icon: 'fa-solid fa-cart-shopping', route: '/venda-online', menuCode: 'venda-online' },
];

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  constructor(private store: Store<IAppState>) {}

  getMenuItems() {
  return this.store.select(selectUser).pipe(
    map((user) => {
      console.log('USER', user);
      console.log('MENUS', user?.menus);

      return MENU_ITEMS.filter(
        (item) =>
          !item.menuCode ||
          !user ||
          !user.menus ||
          user.menus.includes(item.menuCode)
      );
    })
  );
}
}
